module.exports = __webpack_public_path__ + "static/media/bora_bora_beach.30aab8e9.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bora_bora_beach.jpeg
// module id = 60
// module chunks = 0